import { FormControl, Grid } from "@mui/material";
import { InputController } from "@shared/ui/form";
import i18next from 'i18next';

import type { Control, FieldErrors } from "react-hook-form";
import type { ChargedInvoiceAutomaticValues } from "../schema/chargedInvoiceAutomaticSchema";

/** Campos de `userData` (hook legado `useUserProfile`, tipado `unknown`) que este componente lee. */
interface ChargedManualDefaultValue {
    email?: string;
}

export interface ChargedManualProps {
    errors: FieldErrors<ChargedInvoiceAutomaticValues>;
    control: Control<ChargedInvoiceAutomaticValues>;
    defaultValue: ChargedManualDefaultValue;
}

export const ChargedManual = ({errors, control, defaultValue}: ChargedManualProps) => {
    return (
        <>
            <Grid size={12}>
                <FormControl fullWidth>
                    <InputController name="ccEmail" control={control}
                                     type="email"
                                     defaultValue={defaultValue.email} label={i18next.t("ccEmail")}/>
                    {errors.ccEmail &&
                    <span style={{fontSize: 12, color: "red"}}>{errors.ccEmail.message}</span>}
                </FormControl>
            </Grid>
        </>
    );
}
